import "./Infrastructure.module.css";
import Header from "@/reusable_sections/Header";
import InfrastructureOverview from "./sections/InfrastructureOverview";
import MobileMiningSystems from "./sections/MobileMiningSystems";
import ImmersionCooledSystems from "./sections/ImmersionCooledSystems";
import FacilityLocations from "./sections/FacilityLocations";
import Footer from "@/reusable_sections/Footer";
export default function InfrastructurePage() {
  return <div>
      <Header />
      <InfrastructureOverview />
      <MobileMiningSystems />
      <ImmersionCooledSystems />
      <FacilityLocations />
      <Footer />
    </div>;
}